import React from 'react';
import { BrandsAPI } from '../../../../constructs/brands/interface';
import { useAPIContext } from '../../context/api';

export const useSendMediaEmail = () => {
  const { callEndpoint } = useAPIContext();

  const sendMediaEmail = React.useCallback(
    async (bannerId: string, email: string) => {
      try {
        const res = await callEndpoint<BrandsAPI, 'send-banner-email'>(
          'brands',
          `/banners/${bannerId}/send-email`,
          'POST',
          {
            email
          }
        );

        if (!res) throw new Error('Respuesta del servidor inesperada');

        return res;
      } catch (error: any) {
        console.error('Error al enviar el email con los medios del banner:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { sendMediaEmail };
};
